import { AppState } from 'src/app/store/app.states';
import { Directive, ElementRef, Renderer2, Input } from '@angular/core';
import { Store } from '@ngrx/store';

@Directive({
  selector: '[message]',
})
export class MessageDirective {
  @Input() message: string;

  constructor(
    public store: Store<AppState>,
    public renderer: Renderer2,
    public hostElement: ElementRef
  ) {}

  ngOnChanges() {}

  ngAfterViewInit(): void {}
}
